jQuery(document).ready(function($) {

	//--------------------------------------------
	// Menus
	//--------------------------------------------

	$('#main-menu').argonmenu({

		resizeWidth: '767',
		collapserTitle: '',
		animSpeed: 'medium',
		easingEffect: null,
		indentChildren: false,
		childrenIndenter: '&nbsp;'

	});

	$('#main-menu a[href="#"]').click(function(){

		return false;

	});

	selectnav('sub-nav-page', {
	
		activeclass: 'act',
		nested: true,
		indent: '-',
		label: 'Select page'
	
	});

	selectnav('sub-nav-blog', {
	
		activeclass: 'act',
		nested: true,
		indent: '-',
		label: 'Select category'
	
	});

	//--------------------------------------------
	// Sticky Header
	//--------------------------------------------

	var header = document.getElementById('header-1');

	function rpjcStickyHeader() {

		var screenSize = $(window).width();
		var scrollTop  = $(document).scrollTop();

		if (screenSize < 1200 ) return;

		if ( scrollTop > 140 ) {

			$(header).addClass('shrink');

		} else {

			$(header).removeClass('shrink');

		}

	}

	rpjcStickyHeader();

	$(window).scroll(rpjcStickyHeader);

	//--------------------------------------------
	// Carousels
	//--------------------------------------------

	$('#slider').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		arrows: true,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		dots: true

	});

	$('#home-slider').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		arrows: true,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		dots: false

	});

	//--------------------------------------------
	// Lightbox
	//--------------------------------------------

	$('.lightbox-image').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image'
	});

	$('.gallery-item').magnificPopup({
		delegate: 'a',
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image',
		gallery: {
			enabled: true,
			arrowMarkup: '<div title="%title%" class="mfp-arrow mfp-arrow-%dir%"><span></span><span></span></div>'
		}
	});

	//--------------------------------------------
	// Pointer Events for Maps
	//--------------------------------------------

	$('.map iframe').css('pointer-events', 'none');

	$('.map').click(function() {
		
		$(this).find('iframe').css('pointer-events', 'auto');
	
	});

	$('.map').mouseleave(function() {
	
		$(this).find('iframe').css('pointer-events', 'none'); 
	
	});

	//--------------------------------------------
	// Accordion
	//--------------------------------------------

	$('.accordion .accordion-content').hide();

	$('.accordion-handle').click(function(){

		var accordion = $(this).parent().parent();

		if ($('.accordion-content').not(':animated')) {

			if ($(this).parent().hasClass('selected')) {

				$(this).next().slideUp(300).end().parent().removeClass('selected');

			} else {

				$(accordion).find('.accordion-item').removeClass('selected');
				$(this).parent().addClass('selected');
				$(accordion).find('.accordion-content').slideUp(300);
				$(this).next().slideDown(300);

			}

		}

		return false;

	});

	//--------------------------------------------
	// Tabs
	//--------------------------------------------

	$('.tabbed-content .tab-nav li:first-child').addClass('active');
	$('.tabbed-content .tab-window .tab-panel').not(':first-child').hide();

	$('.tabbed-content .tab-nav a').click(function(){

		var target = $(this).attr('href');

		$(this).parent().addClass('active').siblings().removeClass('active');

		$(target).show().siblings().hide();

		return false;

	});

	//--------------------------------------------
	// Scrolling
	//--------------------------------------------

	// Scroll to element

	$('.scroll-to').click(function(){

		var selected = $(this).attr('href');

		$('html, body').animate({scrollTop: $(selected).offset().top},'slow');

        return false;

	});

   // Scroll to top link

    $('a[href="#top"]').click(function(){

        $('html, body').animate({scrollTop:0}, 'slow');

        return false;

    });

	//--------------------------------------------
	// Add placeholder support for older browsers
	//--------------------------------------------

	if(!Modernizr.input.placeholder){

		$('[placeholder]').focus(function() {

			var input = $(this);

			if (input.val() === input.attr('placeholder')) {
				input.val('');
				input.removeClass('placeholder');
			}

		}).blur(function() {

			var input = $(this);

			if (input.val() === '' || input.val() === input.attr('placeholder')) {

				input.addClass('placeholder');
				input.val(input.attr('placeholder'));

			}

		}).blur();

		$('[placeholder]').parents('form').submit(function() {

			$(this).find('[placeholder]').each(function() {

				var input = $(this);

				if (input.val() === input.attr('placeholder')) {

					input.val('');

				}

			});

		});

	}

});